import styled from "styled-components"
import { Link } from "react-router-dom"
import { smallScreen } from "../../Responsive"

export const Container = styled.div`
    position: relative;
    display: flex;
    height: ${props => props.imageHeight};
    width: 100vw;
    top: 0;
    left: 0;
    background: url(${props => props.img});
    background-size: cover;
    background-position: center;
`

export const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-item: center;
    justify-content: center;
    text-align: center;
    z-index: 100;
`

export const Title = styled.h1`
    font-size: var(--fontXL);
    color: var(--lightGrey);

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontL);
    }
`

export const Description = styled.p`
    width: 60%;
    margin: 50px 0px;
    font-size: var(--fontL);
    font-weight: 500;
    letter-spacing: 3px;
    color: var(--lightGrey);
    align-self: center;

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontM);
        margin:10px 0px;
        width: 80%;
    }
`

export const StyledLink = styled(Link)`
    text-decoration: none;
`